import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    TranslateModule.forRoot(),
  ],
  declarations: [],
  exports: [TooltipModule, ModalModule, CollapseModule, TranslateModule],
})
export class SharedModule {}
